const Phases = {
  TODO: 'todo',
  PROGRESS: 'progress',
  DONE: 'done'
};

export default Phases;
